// extracted by mini-css-extract-plugin
export default {"wallet":"ClanWallet-module_wallet_fc513"};